import './styles/graphic.scss';
import data from './data/data.json';

// CNN Sans Display ships with the platform (see styles/fonts.css); only the
// mono face needs loading from Google Fonts.
const FONTS_HREF = 'https://fonts.googleapis.com/css2?family=Roboto+Mono:wght@400;500&display=swap';

// Solid fill used to mask the arrow tab so it reads against the white/card
// surface rather than showing the card below through it.
const CARD_BG = '#ffffff';

function loadFonts() {
  if (document.querySelector('link[data-power-stack-fonts]')) return;
  ['https://fonts.googleapis.com', 'https://fonts.gstatic.com'].forEach((href) => {
    const pre = document.createElement('link');
    pre.rel = 'preconnect';
    pre.href = href;
    if (href.indexOf('gstatic') !== -1) pre.crossOrigin = 'anonymous';
    document.head.appendChild(pre);
  });
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = FONTS_HREF;
  link.setAttribute('data-power-stack-fonts', '');
  document.head.appendChild(link);
}

// Line color darkens light -> dark as power compounds. Generated for N cases
// (i = 0…N-1, t = i/(N-1)): oklch(0.68 - 0.40·t, 0.06 + 0.16·t, 27).
function lineColor(i, total) {
  const t = total > 1 ? i / (total - 1) : 0;
  const l = (0.68 - 0.4 * t).toFixed(3);
  const c = (0.06 + 0.16 * t).toFixed(3);
  return `oklch(${l} ${c} 27)`;
}

// Render dates long-form ("June 26, 2018"). Handles the shapes the sheet can
// produce: a Sheets/Excel serial number (e.g. 46202), an "M/D/YYYY" string, or
// a bare year (left as-is). Anything else is returned untouched.
function longDate(date) {
  return date.toLocaleDateString('en-US', {
    month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC',
  });
}

function formatDate(value) {
  const str = String(value || '').trim();

  // Pure number: a serial date (>= 10000) vs. a bare year like 2026.
  if (/^\d+(\.\d+)?$/.test(str)) {
    const num = Number(str);
    if (num >= 10000) {
      // 25569 = days between the Excel epoch (1899-12-30) and 1970-01-01.
      return longDate(new Date(Math.round((num - 25569) * 86400000)));
    }
    return str;
  }

  const m = str.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (m) {
    return longDate(new Date(Date.UTC(Number(m[3]), Number(m[1]) - 1, Number(m[2]))));
  }

  return str;
}

function connectorSVG(color) {
  return `
    <svg class="ps-edge" viewBox="0 0 100 20" preserveAspectRatio="none" aria-hidden="true">
      <path d="M43 3 L50 18 L57 3 Z" fill="${CARD_BG}"></path>
      <path d="M0 3 H43 L50 18 L57 3 H100" fill="none" stroke="${color}" stroke-width="4" vector-effect="non-scaling-stroke" stroke-linejoin="round" stroke-linecap="round"></path>
    </svg>`;
}

function cardHTML(item, i, total) {
  const isLast = i === total - 1;
  const connector = isLast ? '' : connectorSVG(lineColor(i, total));
  return `
    <div class="ps-row" style="z-index:${total - i}">
      <div class="ps-card">
        ${connector}
        <div class="ps-card-head">
          <span class="ps-domain">${item.domain}</span>
          <span class="ps-date">${formatDate(item.date)}</span>
        </div>
        <h2 class="ps-case-name">${item.name}</h2>
        <p class="ps-holding">${item.holding}</p>
        <div class="ps-grant">
          <span class="ps-grant-text">Powers the presidency to ${item.grant}</span>
        </div>
      </div>
    </div>`;
}

export default function (props, container) {
  loadFonts();

  // Accept either the Google Sheet shape (a flat array of case rows, which is
  // what `npm start` writes) or a { cases: [...] } object.
  const cases = Array.isArray(data) ? data : (data.cases || []);
  const total = cases.length;

  const cards = cases.map((item, i) => cardHTML(item, i, total)).join('');

  const html = `
    <div class="power-stack">
      ${cards}
    </div>`;

  container.html(html);

  // Let the resized/rendered layout report its height back to the parent.
  if (window.pymChild) {
    window.pymChild.sendHeight();
  }
}
